import script from "./UserProfileOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileOrders.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileOrders.vue?vue&type=style&index=0&id=461e2d02&scoped=true&lang=css"
import "./UserProfileOrders.vue?vue&type=style&index=1&id=461e2d02&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-461e2d02"]])

export default __exports__